import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const SortSelect = ({ value, onChange, options, testId }) => (
  <div className="w-full sm:w-60">
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><span className="mr-1 text-slate-500">Ordina per:</span><SelectValue /></SelectTrigger>
      <SelectContent>{options.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`${testId}-${k}`}>{l}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);
